(function () {
  const isMobile = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  const productSlider = () => {
    const sections = document.querySelectorAll(".js-get-section");

    sections.forEach((parent) => {
      const carousel = parent.querySelector(".js-swiper-product-carousel");
      const scrollBar = parent.querySelector(".js-product-carousel-swiper-scrollbar");
      const prev = parent.querySelector(".js-product-carousel-arrow-prev");
      const next = parent.querySelector(".js-product-carousel-arrow-next");

      if (!carousel) return;

      // Initialize Swiper
      const swiperCarousel = new Swiper(carousel, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        grabCursor: true,
        scrollbar: {
          el: scrollBar,
          draggable: true,
        },
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        breakpoints: {
          750: { slidesPerView: 2.5, spaceBetween: 20 },
          990: { slidesPerView: 3.5, spaceBetween: 20 },
          1200: { slidesPerView: 4.5, spaceBetween: 20 },
        },
        mousewheel: {
          forceToAxis: true,
        },
      });

      // Nav tools visibility check
      setTimeout(() => {
        if (prev && next) {
          if (
            prev.classList.contains("swiper-button-lock") ||
            next.classList.contains("swiper-button-lock")
          ) {
            const navTools = parent.querySelector(".product-carousel_nav-tools");
            if (navTools) navTools.style.display = "none";
          }
        }
      }, 150);

      // Video & play icon logic
      const wrappers = parent.querySelectorAll('.influencer-slide-wrapper');

      wrappers.forEach(wrapper => {
        const video = wrapper.querySelector('video');
        if (!video) return;

        const setPlaying = () => wrapper.classList.add('is-playing');
        const unsetPlaying = () => wrapper.classList.remove('is-playing');

        // Sync class to actual video state
        video.addEventListener('play', setPlaying);
        video.addEventListener('pause', unsetPlaying);
        video.addEventListener('ended', unsetPlaying);

        if (isMobile()) {
          // --- MOBILE: Tap to play/pause, thumbnail always shows first ---
          wrapper.addEventListener('click', (e) => {
            // Don't interfere with actual links (shop look / product link)
            if (e.target.closest('a')) return;

            if (video.paused) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });

        } else {
          // --- DESKTOP: Hover to play, leave to pause ---
          wrapper.addEventListener('pointerenter', () => {
            video.play().catch(() => {});
          });

          wrapper.addEventListener('pointerleave', () => {
            video.pause();
          });
        }
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", productSlider);
  } else {
    productSlider();
  }

  // Support Shopify Theme Editor reloads
  document.addEventListener("shopify:section:load", productSlider);
})();
